import { CustomValidators } from './../../../../shared/validators';
import { IcpAlertService } from './../../../../shared/components/refactor-components/ui/icp-alert/icp-alert.service';
import {
  ActionButton,
  ButtonType,
} from './../../../../shared/components/refactor-components/layouts/icp-onboarding/icp-onboarding.model';
import { IcpCarouselModel } from './../../../../shared/components/refactor-components/ui/icp-carousel/carousel-images.model';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import * as Sentry from '@sentry/browser';
import { CustomValidators as NgCustomValidators } from 'ng2-validation';
import { RedefinirSenhaModel } from './redefinir-senha.model';
import { BaseFormComponent } from '../../../../shared/components/refactor-components/base-form/base-form.component';
import { Messages } from '../../../../shared/constants/messages.constant';
import { AppRoutes } from '../../../../shared/constants/routes/routes.constant';
import { RecoveryService } from '../../services/recovery.service';
import { slideInOutAnimation } from '../../animations/router.animations';
import { DirectionsEnum } from '../../../../shared/components/refactor-components/layouts/icp-splitted-screen/icp-splitted-screen.model';
@Component({
  selector: 'reset-password',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
})
export class RedefinirSenhaComponent extends BaseFormComponent {
  redefinirSenha: RedefinirSenhaModel = new RedefinirSenhaModel();
  errors: Array<string>;
  success: string;
  isUser: boolean = true;
  showLoading: boolean;
  passwordShown: boolean = false;
  passwordConfirmationShown: boolean = false;
  contrastSide: string = DirectionsEnum.LEFT;

  images: Array<IcpCarouselModel> = [
    {
      url: '/assets/img/login-carousel-01.svg',
      alt: 'Imagem carrossel login 1',
      caption: 'Potencialize o poder de <br> pagamento <b>dos seus pacientes.</b>',
    },
    {
      url: '/assets/img/login-carousel-02.svg',
      alt: 'Imagem carrossel login 2',
      caption: '<b>Antecipe já!</b> Recursos para <br> sua clínica sem gerar dívidas.',
    },
    {
      url: '/assets/img/login-carousel-03.svg',
      alt: 'Imagem carrossel login 3',
      caption:
        'Quer ter mais tempo para curtir a <br> vida? <b>Otimize seus atendimentos.</b>',
    },
  ];

  btnRedefinirSenha: ActionButton = {
    buttonType: ButtonType.Loading,
    text: 'Redefinir senha',
    buttonClass: 'button-primary',
    showLoading: false,
  };

  actions: ActionButton[] = [this.btnRedefinirSenha];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private recoveryService: RecoveryService,
    private icpAlert: IcpAlertService
  ) {
    super(
      { email: '', password: '', password_confirmation: '' },
      {
        email: {
          required: Messages.EMAIL_REQUIRED,
          email: Messages.EMAIL_INVALID,
        },
        password: {
          required: Messages.PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
          passwordStrength: Messages.PASSWORD_STRENGTH,
        },
        password_confirmation: {
          required: Messages.PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
          equalTo: Messages.PASSWORD_EQUAL,
        },
      },
      fb
    );
  }

  ngOnInit() {
    this.buildForm();
  }

  initializeForm(): FormGroup {
    let password: FormControl = new FormControl(this.redefinirSenha.password, [
      Validators.required,
      Validators.minLength(6),
      CustomValidators.passwordStrength,
    ]);
    let password_confirmation: FormControl = new FormControl(
      this.redefinirSenha.password_confirmation,
      [Validators.required, Validators.minLength(6), NgCustomValidators.equalTo(password)]
    );

    return this.fb.group({
      email: [
        this.redefinirSenha.email,
        Validators.compose([Validators.required, NgCustomValidators.email]),
      ],
      password: password,
      password_confirmation: password_confirmation,
    });
  }

  sendForm(): any {
    let values = this.form.value;
    this.showLoading = true;
    this.redefinirSenha = this.form.value;
    this.route.params.subscribe((params: any) => {
      this.redefinirSenha.token = params['token'];
    });
    return this.recoveryService
      .resetPassword(
        this.redefinirSenha.token,
        values.email,
        values.password,
        values.password_confirmation
      )
      .subscribe(
        (res) => {
          this.handleResponseSuccess(res);
        },
        (res) => {
          this.handleResponseErrors(res);
        }
      );
  }

  handleResponseSuccess(res: any) {
    this.errors = [];
    this.success = res.messages;
    this.icpAlert.success(this.success);
    setTimeout(() => {
      this.router.navigate([AppRoutes.LOGIN]);
    }, 1500);
  }

  handleResponseErrors(errors) {
    this.showLoading = false;
    if (errors && errors.error) {
      errors && Sentry.captureException(errors);
      const message = errors.error.messages[0];
      if (message && message === 'Token inválido') {
        this.icpAlert.error(
          'E-mail de recuperação de senha expirado,\nfavor tentar novamente.'
        );
        setTimeout(() => {
          this.router.navigate([AppRoutes.FORGOT_PASSWORD]);
        }, 1000);
      } else {
        this.icpAlert.error('O email informado não foi encontrado');
      }
    }
  }

  handleErrors() {}

  togglePasswordVisiblity(field: string) {
    if (field == 'password') {
      let element = <HTMLInputElement>document.getElementById('password');
      element.type == 'password' ? (element.type = 'text') : (element.type = 'password');
      element.type == 'password'
        ? (this.passwordShown = false)
        : (this.passwordShown = true);
    }
  }

  togglePasswordConfirmationVisiblity(field: string) {
    if (field == 'password_confirmation') {
      let element = <HTMLInputElement>document.getElementById('password_confirmation');
      element.type == 'password' ? (element.type = 'text') : (element.type = 'password');
      element.type == 'password'
        ? (this.passwordConfirmationShown = false)
        : (this.passwordConfirmationShown = true);
    }
  }

  submitForm() {
    if (this.form.valid) {
      this.sendForm();
    }
  }
}
